import type { FunctionComponent } from 'react';
import { WCCFooterItems } from './constants';

const Feedback = () => (
  <div className="bg-accent-highlight mb-1 w-full basis-[100%] -translate-y-[50%] rounded px-3 py-1">
    <a
      href={WCCFooterItems.feedback.url}
      className="text-text-body hover:text-text-dark focus:bg-text-body focus:text-text-contrast focus:outline-text-body rounded underline focus:outline focus:outline focus:outline-2"
    >
      {WCCFooterItems.feedback.text}
    </a>
  </div>
);

const TopLinks = () => (
  <div className="basis-[100%] lg:basis-[50%]">
    <nav
      className="flex flex-col items-start gap-3"
      aria-label="Council information"
    >
      {WCCFooterItems.menu.map((item) => (
        <a
          key={item.url}
          href={item.url}
          className="hover:bg-action-button-hover focus:text-brand-primary focus:bg-action-focus focus:outline-action-focus text-body rounded leading-snug focus:outline focus:outline-2"
          rel="noopener noreferrer"
          target="_blank"
        >
          {item.text} <span className="sr-only">(link opens new window)</span>
        </a>
      ))}
    </nav>
    <nav className="mt-7 flex gap-3" aria-label="Social media">
      {WCCFooterItems.socialMedia.map((item) => (
        <a
          key={item.url}
          href={item.url}
          className="focus:outline-accent-highlight focus:bg-accent-highlight rounded focus:outline focus:outline-2 focus:outline-offset-0"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.ariaLabel}
        >
          <img src={item.src} alt={item.alt} className="h-8 w-8" />
        </a>
      ))}
    </nav>
  </div>
);

const FooterLogo = () => (
  <div className="border-text-contrast order-4 flex basis-[100%] border-t border-opacity-10 py-8 lg:order-3 lg:mb-9 lg:basis-[50%] lg:items-end lg:justify-end lg:border-t-0 lg:py-0">
    <a
      href={WCCFooterItems.logo.url}
      className="focus:bg-accent-highlight focus:outline-accent-highlight w-[10rem] rounded focus:outline focus:outline-4 focus:outline-offset-0 lg:w-[15rem]"
      rel="noopener noreferrer"
      target="_blank"
      aria-label={WCCFooterItems.logo.ariaLabel}
    >
      <img
        className="w-full"
        src={WCCFooterItems.logo.src}
        alt={WCCFooterItems.logo.alt}
      />
    </a>
  </div>
);

const BottomLinks = () => (
  <nav
    className="border-text-contrast order-3 mt-6 flex basis-[100%] flex-col flex-wrap items-start gap-x-4 gap-y-3 border-t border-opacity-10 py-5 lg:order-4 lg:flex-row lg:justify-center"
    aria-label="More council information"
  >
    {WCCFooterItems.bottomLinks.map((item) => (
      <a
        key={item.url}
        href={item.url}
        className="hover:bg-action-button-hover focus:text-brand-primary focus:bg-action-focus focus:outline-action-focus text-body rounded leading-snug focus:outline focus:outline-2"
        rel="noopener noreferrer"
        target="_blank"
      >
        {item.text} <span className="sr-only">(link opens new window)</span>
      </a>
    ))}
  </nav>
);

export const WCCFooter: FunctionComponent = () => (
  <footer className="bg-brand-primary text-text-contrast section-horizontal-padding mt-auto flex w-full flex-wrap items-stretch justify-center pb-5">
    <Feedback />
    <TopLinks />
    <FooterLogo />
    <BottomLinks />
  </footer>
);
